export default __webpack_public_path__ + "static/media/cog.afd3b879.svg";